module.exports = __webpack_public_path__ + "media/svg/experiences-selected-6ae9b9b1.svg";